<script setup lang="ts">
import SnapShotDatePicker from "@/ui/components/date/SnapShotDatePicker.vue";
import { Ref, ref, toRefs, defineProps, defineEmits, watch } from "vue";
import dayjs, { Dayjs } from "dayjs";
import TimeContextPicker from "@/ui/components/date/TimeContextPicker.vue";

const isSnapshotSelectionVisible = defineModel<boolean>();

const props = withDefaults(
	defineProps<{
		period_measurement: string;
		period_measurement_parsed: Date;
		transaction_snapshot?: string;
		transaction_snapshot_parsed?: Date;
		showTransactionSnapshot?: boolean;
		isTimeContext?: boolean;
	}>(),
	{
		showTransactionSnapshot: false,
		isTimeContext: false,
	}
);

const emit = defineEmits<{
	(e: "update:period_measurement", value: string): void;
	(e: "update:period_measurement_parsed", value: Date): void;
	(e: "update:transaction_snapshot", value: string): void;
	(e: "update:transaction_snapshot_parsed", value: Date): void;
}>();

const {
	period_measurement,
	period_measurement_parsed,
	transaction_snapshot,
	transaction_snapshot_parsed,
	showTransactionSnapshot,
} = toRefs(props);

const tmpDataSnapshotDate: Ref<string | null> = ref(period_measurement.value);
const tmpDataSnapshotDateParsed: Ref<Dayjs | null> = ref(
	dayjs(period_measurement_parsed.value)
);
const tmpTransactionSnapshotDate: Ref<string | null> = ref(
	transaction_snapshot.value
);
const tmpTransactionSnapshotDateParsed: Ref<Dayjs | null> = ref(
	dayjs(transaction_snapshot_parsed.value)
);

const applyDataDateToStore = () => {
	setTimeout(() => {
		emit(
			"update:period_measurement_parsed",
			tmpDataSnapshotDateParsed.value.toDate()
		);
		emit("update:period_measurement", tmpDataSnapshotDate.value);
		isSnapshotSelectionVisible.value = false;
	}, 100);
};

const applyTransactionDateToStore = () => {
	setTimeout(() => {
		emit(
			"update:transaction_snapshot_parsed",
			tmpTransactionSnapshotDateParsed.value.toDate()
		);
		emit("update:transaction_snapshot", tmpTransactionSnapshotDate.value);
		isSnapshotSelectionVisible.value = false;
	}, 100);
};

const selectedTab = ref("data");

watch(showTransactionSnapshot, () => {
	if (!showTransactionSnapshot.value) {
		selectedTab.value = "data";
	}
});
</script>

<template>
	<v-card elevation="9" v-if="!isTimeContext">
		<v-tabs v-if="showTransactionSnapshot" v-model="selectedTab">
			<v-tab value="data">Data</v-tab>
			<v-tab value="transaction">Transaction</v-tab>
		</v-tabs>
		<v-divider v-if="showTransactionSnapshot" />
		<v-tabs-window v-model="selectedTab">
			<v-tabs-window-item :value="'data'">
				<snap-shot-date-picker
					v-model="tmpDataSnapshotDate"
					v-model:parsed="tmpDataSnapshotDateParsed"
					@apply-date="applyDataDateToStore"
				></snap-shot-date-picker>
			</v-tabs-window-item>
			<v-tabs-window-item :value="'transaction'">
				<snap-shot-date-picker
					v-model="tmpTransactionSnapshotDate"
					v-model:parsed="tmpTransactionSnapshotDateParsed"
					@apply-date="applyTransactionDateToStore"
				></snap-shot-date-picker>
			</v-tabs-window-item>
		</v-tabs-window>
	</v-card>
	<time-context-picker
		v-else
		v-model="tmpDataSnapshotDate"
		v-model:parsed="tmpDataSnapshotDateParsed"
		@apply-date="applyDataDateToStore"
	/>
</template>

<style lang="scss">
.cm-wrap {
	height: 100%;
}
.cm-scroller {
	overflow: auto;
}
</style>
